import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  { path: 'traspaso', redirectTo: 'traspaso/por-que-cambiarme', pathMatch: 'full' },
  {
    path: 'traspaso',
    children: [
      {
        path: 'por-que-cambiarme',
        loadChildren: () => import('./why-transfer/why-transfer.module').then(m => m.WhyTransferPageModule)
      },
      {
        path: 'estado',
        loadChildren: () => import('./transfer-state/transfer-state.module').then(m => m.TransferStatePageModule)
      },
    ]
  },
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [RouterModule]
})
export class TransferRoutingModule { }
